import { Project } from '../../types';

// Mock data: proyectos asignados al departamento imprenta
export const MOCK_IMPRENTA: Project[] = [
  {
    id: 20,
    reference: 'PRJ-020',
    title: 'Flyers Corporativos Q2 — TechCorp',
    description: 'Flyers A5 a doble cara, 2000 unidades. Papel couché 150g.',
    status: 'in_progress',
    currentDepartment: 'imprenta',
    notifications: { email: true, onStateChange: true },
    client: { id: 2, name: 'TechCorp SL', company: 'TechCorp SL' },
    dueDate: new Date(Date.now() + 1 * 86400000).toISOString(),
    createdAt: new Date(Date.now() - 2 * 86400000).toISOString(),
    progress: 30,
    steps: [
      { id: 101, department: 'gestor',   orderIndex: 0, status: 'done',        data: {} },
      { id: 102, department: 'imprenta', orderIndex: 1, status: 'in_progress', data: {} },
      { id: 103, department: 'almacen',  orderIndex: 2, status: 'pending',     data: {} },
      { id: 104, department: 'embalaje', orderIndex: 3, status: 'pending',     data: {} },
    ],
  },
  {
    id: 21,
    reference: 'PRJ-021',
    title: 'Carteles Promocionales Verano',
    description: 'Carteles B1 plastificados, 50 unidades.',
    status: 'in_progress',
    currentDepartment: 'imprenta',
    notifications: { email: false, onStateChange: true },
    client: { id: 5, name: 'Retail Max', company: 'Retail Max SA' },
    dueDate: new Date(Date.now() - 1 * 86400000).toISOString(),
    createdAt: new Date(Date.now() - 4 * 86400000).toISOString(),
    progress: 20,
    steps: [
      { id: 105, department: 'gestor',    orderIndex: 0, status: 'done',        data: {} },
      { id: 106, department: 'financiero',orderIndex: 1, status: 'done',        data: {} },
      { id: 107, department: 'imprenta',  orderIndex: 2, status: 'in_progress', data: {} },
      { id: 108, department: 'embalaje',  orderIndex: 3, status: 'pending',     data: {} },
    ],
  },
  {
    id: 22,
    reference: 'PRJ-022',
    title: 'Tarjetas Visita — Estudio Creativo',
    description: 'Tarjetas 9x5cm con relieve dorado, 500 unidades.',
    status: 'in_progress',
    currentDepartment: 'imprenta',
    notifications: { email: true, onStateChange: false },
    client: { id: 6, name: 'Estudio Creativo', company: 'Estudio Creativo SL' },
    dueDate: new Date(Date.now() + 5 * 86400000).toISOString(),
    createdAt: new Date(Date.now() - 1 * 86400000).toISOString(),
    progress: 10,
    steps: [
      { id: 109, department: 'gestor',   orderIndex: 0, status: 'done',        data: {} },
      { id: 110, department: 'imprenta', orderIndex: 1, status: 'in_progress', data: {} },
      { id: 111, department: 'embalaje', orderIndex: 2, status: 'pending',     data: {} },
    ],
  },
];
